import { TabFallback } from '@/components/TabFallback';
import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import type { RouteHandle } from './types';

const Dashboard = lazy(() => import('@/pages/Dashboard').then((m) => ({ default: m.Dashboard })));

const handle: RouteHandle = {
  crumb: 'Dashboard',
  requiredPermissions: [],
};

export const dashboardRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    element: (
      <Suspense fallback={<TabFallback />}>
        <Dashboard />
      </Suspense>
    ),
    handle,
  },
];
